import React from 'react';
import ShipmentListItem from '../ShipmentListItem';
import ShipmentItemHeader from '../ShipmentItemHeader';
import * as S from './ShipmentList.style';

const ShipmentList: React.FC<{
  shipments: any[];
  isNowUnavailableHour: boolean;
  isNowOfflineHour: boolean;
  nextAvailableSlot: any;
  busyHourDisclaimer: string;
}> = ({
  shipments,
  isNowUnavailableHour = false,
  isNowOfflineHour = false,
  nextAvailableSlot = {},
  busyHourDisclaimer,
}) => {
  const totalShipments = shipments.length;

  return (
    <>
      {shipments.map((shipment, index) => (
        <S.Shipment key={shipment.identifier}>
          <ShipmentItemHeader
            shipmentNumber={index + 1}
            totalShipments={totalShipments}
            totalShipmentItems={shipment.count}
            shipmentType={shipment.shipmentType}
            shopName={shipment.shopName}
          />

          <ShipmentListItem
            shipment={shipment}
            isNowOfflineHour={isNowOfflineHour}
            isNowUnavailableHour={isNowUnavailableHour}
            nextAvailableSlot={nextAvailableSlot}
            totalShipments={totalShipments}
            busyHourDisclaimer={busyHourDisclaimer}
          />
        </S.Shipment>
      ))}
    </>
  );
};

export default ShipmentList;
